const udCart = Vue.createApp({
  delimiters: ["{", "}"],
  data() {
    return {
      cart: null,
      isCartOpen: false,
      carousel: null,

      recommendedProducts: null,

      promoItem: null,
      countdown: null,

      loading: true,
      view: "slide", //slide or page
      checkoutLoading: false,
      showCheckoutSpinner: true,
    };
  },

  computed: {
    bundleQuantity() {
      return this.cart.items
        .filter((x) => x.product_type !== "Shipping Protection")
        .map((item) => item.quantity)
        .reduce((prev, next) => prev + next);
    },

    percentageSavings() {
      return ((this.cart.total_discount / this.cart.original_total_price) * 100).toFixed(0);
    },

    meetsQuantityRules() {
      if (this.cart.items.filter((item) => item.product_type == "Cookie Dough").length > 0) {
        return (
          this.cart.items.reduce((acc, item) => (item.product_type == "Cookie Dough" ? acc + item.quantity : acc), 0) >=
          6
        );
      }
      return true;
    },

    quantityNeeded() {
      if (!this.meetsQuantityRules) {
        const quantityInCart = this.cart.items.reduce(
          (acc, item) => (item.product_type == "Cookie Dough" ? acc + item.quantity : acc),
          0
        );
        return 6 - quantityInCart;
      }

      return 0;
    },
  },

  watch: {
    cart(newCart, oldCart) {
      if (newCart?.items.length !== oldCart?.items.length) {
        this.lastItemAdded = this.cart.items[0];
      }

      if (newCart?.items.length == oldCart?.items.length && newCart?.item_count !== oldCart?.item_count) {
        newCart.items.forEach((item) => {
          let match = oldCart.items.find((x) => x.id == item.id);
          if (item.quantity !== match.quantity) {
            this.lastItemAdded = match;
          }
        });
      }
    },

    promoItem: {
      deep: true,

      handler() {
        let variants = this.promoItem.variants;
        let options = [];

        for (const [key, value] of Object.entries(this.promoItem.selectedOptions)) {
          options.push(value);
        }

        let variant = variants.find((variant) => {
          let variantOptions = variant.title.split(" / ");
          if (variantOptions.length == options.length && variantOptions.every((x) => options.includes(x))) {
            return variant;
          }
        });

        this.promoItem.selectedVariant = variant;
      },
    },
  },

  methods: {
    closeCart() {
      this.isCartOpen = false;
    },

    openCart() {
      if (this.view == "page") {
        if (window.innerWidth > 576) {
          window.location = "/cart";
        } else {
          this.isCartOpen = true;
        }
      }

      if (this.view == "slide") {
        this.isCartOpen = true;
      }
    },

    imageSize(src, size) {
      return src.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
        return "_" + size + match;
      });
    },

    updateCart(cart) {
      this.cart = JSON.parse(JSON.stringify(cart));

      if (this.cart.item_count == 0) {
        document.getElementById("cart-qty-indicator").style.display = "none";
      } else {
        document.getElementById("cart-qty-indicator").style.display = "block";
        document.getElementById("cart-qty-indicator").innerHTML = this.cart.item_count;
      }
    },

    updateQuantity(index, quantity) {
      quantity = this.cart.items[index].quantity + quantity;
      let line_item_index = index + 1; // CartJS index starts at 1

      CartJS.updateItem(line_item_index, quantity);
    },
    removeItem(index) {
      let line_item_index = index + 1; // CartJS index starts at 1

      CartJS.updateItem(line_item_index, 0);
    },
    formatMoney(money) {
      return Shopify.formatMoney(money);
    },

    fetchPromoItem(handle) {
      fetch(`/products/${handle}.json`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.promoItem = {
            ...data.product,
            selectedVariant: data.product.variants[0],
            selectedOptions: {},
          };

          this.promoItem.options.forEach((option) => {
            this.promoItem.selectedOptions[option.name] = option.values[0];
          });
        });
    },
    countdownTimer(endDate) {
      let ticker = setInterval(() => {
        let now = new Date();
        let distance = new Date(endDate) - now;

        // var hours = 23 - now.getHours();
        // var minutes = 59 - now.getMinutes();
        // var seconds = 59 - now.getSeconds();

        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        hours += days * 24;

        // if (days / 10 < 1) {
        //   days = '0' + days;
        // }

        if (hours / 10 < 1) {
          hours = "0" + hours;
        }

        if (minutes / 10 < 1) {
          minutes = "0" + minutes;
        }

        if (seconds / 10 < 1) {
          seconds = "0" + seconds;
        }

        this.countdown = {
          // days,
          hours,
          minutes,
          seconds,
          // display: days + ':' + hours + ':' + minutes + ':' + seconds
          display: hours + ":" + minutes + ":" + seconds,
        };

        if (distance < 0) {
          clearInterval(ticker);
        }
      }, 1000);
    },

    handleCheckout(event) {
      if (!this.meetsQuantityRules) {
        event.preventDefault();
        return;
      }
      this.checkoutLoading = true;
    },
  },

  created() {},

  mounted() {},
}).mount("#udCart");

$("#cart-toggle").click(function (event) {
  if (!$(event.target).hasClass("sticky-el")) {
    udCart.isCartOpen ? udCart.closeCart() : udCart.openCart();
  }
});

$(window).on("ud-cart-open", (event) => {
  udCart.openCart();
});

$(window).on("ud-cart-close", (event) => {
  udCart.closeCart();
});

$(document).ready(function () {
  if (window.location.href.includes("#cart")) {
    udCart.openCart();
  }
});

$(document).on("cart.ready", (event, cart) => {
  udCart.updateCart(cart);
});

$(document).on("cart.requestStarted", (event, cart) => {
  udCart.loading = true;
});
$(document).on("reBuyAdd", (event, cart) => {
  window.location.href += "#cart";
  location.reload();
});
$(document).on("cart.requestComplete", (event, cart) => {
  udCart.openCart();

  udCart.updateCart(cart);
  udCart.loading = false;
});
